import { HardTermination } from '../shared';

export const OutOfCoverage = () => (
  <HardTermination
    title="We’re not in your state yet"
    body="But we will be soon. Please check back again."
  />
);
